module.exports = __webpack_public_path__ + "img/new_logo_black.634ac704.svg";